import { FC, PropsWithChildren, useCallback, useState } from "react";

import { TwoFactorContext, TwoFactorModalConfig } from "../contexts/TwoFactorContext";

// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { TwoFactorVerificationModal } from "@/components/TwoFactorVerificationModal/TwoFactorVerificationModal";

export const TwoFactorProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [config, setConfig] = useState<TwoFactorModalConfig | null>(null);

  const openTwoFactorModal = useCallback((modalConfig: TwoFactorModalConfig) => {
    setConfig(modalConfig);
    setIsOpen(true);
  }, []);

  const closeTwoFactorModal = useCallback(() => {
    setIsOpen(false);
    setConfig(null);
  }, []);

  return (
    <TwoFactorContext.Provider
      value={{
        isOpen,
        config,
        openTwoFactorModal,
        closeTwoFactorModal,
      }}
    >
      {children}
      {isOpen && config && (
        <TwoFactorVerificationModal
          open={isOpen}
          preferredMethod={config.preferredMethod}
          maskedPhoneNumber={config.maskedPhoneNumber}
          hasSmsFallback={config.hasSmsFallback}
          isSmsVerificationNext={config.isSmsVerificationNext}
          onSubmit={config.onSubmit}
          onRequestSmsFallback={config.onRequestSmsFallback}
          onCancel={config.onCancel}
        />
      )}
    </TwoFactorContext.Provider>
  );
};
